const FALLBACK_CURRENCY_CODES = [
  'AED', 'AFN', 'ALL', 'AMD', 'ANG', 'AOA', 'ARS', 'AUD', 'AWG', 'AZN',
  'BAM', 'BBD', 'BDT', 'BGN', 'BHD', 'BIF', 'BMD', 'BND', 'BOB', 'BRL',
  'BSD', 'BTN', 'BWP', 'BYN', 'BZD', 'CAD', 'CDF', 'CHF', 'CLP', 'CNY',
  'COP', 'CRC', 'CUC', 'CUP', 'CVE', 'CZK', 'DJF', 'DKK', 'DOP', 'DZD',
  'EGP', 'ERN', 'ETB', 'EUR', 'FJD', 'FKP', 'GBP', 'GEL', 'GHS', 'GIP',
  'GMD', 'GNF', 'GTQ', 'GYD', 'HKD', 'HNL', 'HRK', 'HTG', 'HUF', 'IDR',
  'ILS', 'INR', 'IQD', 'IRR', 'ISK', 'JMD', 'JOD', 'JPY', 'KES', 'KGS',
  'KHR', 'KMF', 'KPW', 'KRW', 'KWD', 'KYD', 'KZT', 'LAK', 'LBP', 'LKR',
  'LRD', 'LSL', 'LYD', 'MAD', 'MDL', 'MGA', 'MKD', 'MMK', 'MNT', 'MOP',
  'MRU', 'MUR', 'MVR', 'MWK', 'MXN', 'MYR', 'MZN', 'NAD', 'NGN', 'NIO',
  'NOK', 'NPR', 'NZD', 'OMR', 'PAB', 'PEN', 'PGK', 'PHP', 'PKR', 'PLN',
  'PYG', 'QAR', 'RON', 'RSD', 'RUB', 'RWF', 'SAR', 'SBD', 'SCR', 'SDG',
  'SEK', 'SGD', 'SHP', 'SLE', 'SLL', 'SOS', 'SRD', 'SSP', 'STN', 'SVC',
  'SYP', 'SZL', 'THB', 'TJS', 'TMT', 'TND', 'TOP', 'TRY', 'TTD', 'TWD',
  'TZS', 'UAH', 'UGX', 'USD', 'UYU', 'UZS', 'VES', 'VND', 'VUV', 'WST',
  'XAF', 'XCD', 'XCG', 'XDR', 'XOF', 'XPF', 'XSU', 'YER', 'ZAR', 'ZMW',
  'ZWG', 'ZWL',
] as const;

interface IntlCurrencySupport {
  supportedValuesOf?: (key: string) => string[];
  DisplayNames?: new (
    locales: string[],
    options: { type: 'currency' },
  ) => { of: (code: string) => string | undefined };
}

function currencyCodes(): string[] {
  const intl = Intl as unknown as IntlCurrencySupport;
  if (typeof intl.supportedValuesOf === 'function') {
    try {
      const supported = intl.supportedValuesOf('currency');
      if (supported.length > 0) return supported;
    } catch {
      // Older browser: use the complete bundled ISO fallback below.
    }
  }
  return [...FALLBACK_CURRENCY_CODES];
}

function currencyNames() {
  const Constructor = (Intl as unknown as IntlCurrencySupport).DisplayNames;
  if (!Constructor) return null;
  try {
    return new Constructor(['en'], { type: 'currency' });
  } catch {
    return null;
  }
}

export const CURRENCY_CODES = currencyCodes();

const names = currencyNames();
export const CURRENCY_OPTIONS = CURRENCY_CODES.map((code) => {
  const name = names?.of(code);
  return { value: code, label: name && name !== code ? `${code} — ${name}` : code };
});
